// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file types/v1/localtime.proto (package types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message types.v1.LocalTime
 */
export const LocalTime = /*@__PURE__*/ proto3.makeMessageType(
  "types.v1.LocalTime",
  () => [
    { no: 1, name: "time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message types.v1.Timespan
 */
export const Timespan = /*@__PURE__*/ proto3.makeMessageType(
  "types.v1.Timespan",
  () => [
    { no: 1, name: "start", kind: "message", T: LocalTime },
    { no: 2, name: "end", kind: "message", T: LocalTime },
  ],
);

/**
 * @generated from message types.v1.Duration
 */
export const Duration = /*@__PURE__*/ proto3.makeMessageType(
  "types.v1.Duration",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "unit", kind: "enum", T: proto3.getEnumType(Duration_Unit) },
  ],
);

/**
 * @generated from enum types.v1.Duration.Unit
 */
export const Duration_Unit = /*@__PURE__*/ proto3.makeEnum(
  "types.v1.Duration.Unit",
  [
    {no: 0, name: "UNIT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UNIT_SECONDS", localName: "SECONDS"},
    {no: 2, name: "UNIT_MINUTES", localName: "MINUTES"},
    {no: 3, name: "UNIT_HOURS", localName: "HOURS"},
    {no: 4, name: "UNIT_DAYS", localName: "DAYS"},
    {no: 5, name: "UNIT_WEEKS", localName: "WEEKS"},
    {no: 6, name: "UNIT_MONTHS", localName: "MONTHS"},
    {no: 7, name: "UNIT_YEARS", localName: "YEARS"},
  ],
);

